import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { z } from "zod";
import { useAuth } from "@clerk/clerk-react";

export const SearchResultType = z.enum([
  "ARTICLE",
  "SCAM",
  "COURSE",
  "LESSON",
  "DAILY_TIP",
  "SCAM_OF_THE_DAY",
  "GLOBAL_EVENT",
]);

export const searchResultSchema = z.object({
  id: z.string(),
  type: SearchResultType,
  title: z.string(),
  description: z.string().optional().nullable(),
  slug: z.string().optional().nullable(),
  image: z.string().optional().nullable(),
});

export type SearchResult = z.infer<typeof searchResultSchema>;

export function useAppSearch(params: { q: string; types?: string; limit?: number }) {
  const { getToken } = useAuth();
  const enabled = Boolean(params.q && params.q.trim().length > 0);

  return useQuery({
    queryKey: ["appSearch", params],
    queryFn: async () => {
      const token = await getToken();
      const resp = await axios.get(`${import.meta.env.VITE_API_URL}/app/search`, {
        params: {
          q: params.q,
          types: params.types,
          limit: params.limit,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return z.array(searchResultSchema).parse(resp.data);
    },
    enabled,
    staleTime: 30_000,
  });
}


